// oxlint-disable-next-line typescript/no-unnecessary-type-parameters
export function jsonParse<T>(content: string): T {
    // oxlint-disable-next-line typescript/no-unsafe-type-assertion
    return JSON.parse(content) as T;
}
